var _defs, _circle, _path, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg73Prv(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_10",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#03142a;}.cls-2{fill:#fff;}.cls-3{fill:none;stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 16,
    cy: 16,
    r: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16,20.71c.24-.2,.35-.48,.35-.76,0-.26-.1-.51-.31-.72l-3.35-3.24,3.35-3.24c.43-.42,.41-1.08-.04-1.47-.45-.4-1.17-.38-1.6,.04l-4.09,3.95c-.41,.4-.41,1.03,0,1.43l4.09,3.95c.43,.42,1.15,.43,1.6,.04Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 11,
    y1: 16,
    x2: 21,
    y2: 16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg73Prv);
export default __webpack_public_path__ + "static/media/73-prv.64980ff5e881f75c2e5a63fdd27c133f.svg";
export { ForwardRef as ReactComponent };